import type { FC } from "react";
import React from "react";

import { Separator } from "@jti/core-components/components/Separator";
import { type FreeGift as FreeGiftType } from "@jti/magento";

import type { SelectedFreeGifts, SetSelectedFreeGiftQuantity } from "@checkout/hooks/useFreeGifts";

import { FreeGift } from "../FreeGift";

import styles from "./ProductFreeGifts.module.scss";

type ProductFreeGiftsProps = {
  freeGifts: FreeGiftType[];
  limit: number;
  parentItemId: string;
  parentItemSku: string;
  hasReachedBasketLimit: boolean;
  selectedFreeGifts: SelectedFreeGifts;
  setSelectedFreeGiftQuantity: SetSelectedFreeGiftQuantity;
  hasMultipleProductsWithGifts: boolean;
};

const ProductFreeGifts: FC<ProductFreeGiftsProps> = ({
  freeGifts,
  limit,
  parentItemId,
  parentItemSku,
  hasReachedBasketLimit,
  selectedFreeGifts,
  setSelectedFreeGiftQuantity,
}) => {
  const selectedProductGifts = selectedFreeGifts[parentItemId] || {};
  const selectedProductGiftsCount = Object.values(selectedProductGifts).reduce((acc, count) => acc + count, 0);
  const hasReachedProductLimit = selectedProductGiftsCount >= limit;

  return (
    <div>
      {freeGifts.map(({ name, sku: giftSku, image, tooltip_info: tooltip, quantityAddedToCart }) => {
        return (
          <React.Fragment key={`${parentItemId}-${giftSku}`}>
            <FreeGift
              key={`${parentItemId}-${giftSku}`}
              name={name}
              parentItemId={parentItemId}
              parentItemSku={parentItemSku}
              giftSku={giftSku}
              image={image}
              hasReachedLimit={hasReachedBasketLimit || hasReachedProductLimit}
              selectedFreeGifts={selectedFreeGifts}
              setSelectedFreeGiftQuantity={setSelectedFreeGiftQuantity}
              tooltip={tooltip}
              quantityAddedToCart={quantityAddedToCart}
            />
            <div className={styles.separator}>
              <Separator />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProductFreeGifts;
